<template>
    <img src="/images/logo.png" alt="DOUSCHOOL.AI" class="max-w-full w-auto max-h-12">
</template>
